import { MenuIcon } from 'lucide-react';

import { Menu } from '@/components/layout/menu';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTrigger,
} from '@/components/ui/sheet';
import { Link } from 'react-router-dom';

export function SheetMenu() {
  return (
    <Sheet>
      <SheetTrigger className="lg:hidden" asChild>
        <Button className="h-8" variant="outline" size="icon">
          <MenuIcon size={20} />
        </Button>
      </SheetTrigger>
      <SheetContent className="sm:w-72 px-3 h-full flex flex-col" side="left">
        <SheetHeader>
          <Button variant="link" asChild>
            <Link to="/">
              <img
                className="w-28 lg:w-32 block dark:hidden"
                src="/assets/logos/studypro-ceo-black.svg"
                alt="Light mode logo"
              />
              <img
                className="w-28 lg:w-32 hidden dark:block"
                src="/assets/logos/studypro-ceo-white.svg"
                alt="Light mode logo"
              />
            </Link>
          </Button>
        </SheetHeader>
        <Menu isOpen />
      </SheetContent>
    </Sheet>
  );
}
